interface SicopMarkProps {
  size?: number;
  className?: string;
  /** `inverted` é a versão usada sobre o azul escuro da sidebar. */
  variant?: 'brand' | 'inverted';
}

/** Marca do SICOP (mesma do design). */
export function SicopMark({ size = 64, className, variant = 'brand' }: SicopMarkProps) {
  const inverted = variant === 'inverted';

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="8" fill={inverted ? '#fff' : '#16439C'} />
      <path d="M9 8h14l-7 8zM9 24h14l-7-8z" fill={inverted ? '#002447' : '#fff'} />
    </svg>
  );
}

/** Logo colorido do Google usado no botão. */
export function GoogleMark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <path
        fill="#EA4335"
        d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.4 17.7 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.5 24.5c0-1.7-.2-3.3-.5-4.9H24v9.3h12.7c-.6 3-2.3 5.6-4.8 7.3l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"
      />
      <path fill="#FBBC05" d="M10.4 28.7a14.5 14.5 0 010-9.4l-7.8-6.1a24 24 0 000 21.6z" />
      <path
        fill="#34A853"
        d="M24 48c6.2 0 11.4-2 15.4-5.9l-7.5-5.8c-2.1 1.4-4.8 2.2-7.9 2.2-6.3 0-11.7-3.9-13.6-9.8l-7.8 6.1C6.5 42.6 14.6 48 24 48z"
      />
    </svg>
  );
}
